import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "cookie_consent_v1";

// Aviso de cookies/armazenamento local (LGPD). O flag do aceite fica no
// localStorage — é o consentimento em si, não dado de negócio.
export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));

  const accept = () => {
    localStorage.setItem(KEY, new Date().toISOString());
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-consent"
          className="dark fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-4 sm:max-w-sm z-[70] rounded-2xl border border-border bg-popover text-foreground shadow-2xl shadow-black/40 p-4 space-y-3"
        >
          <div className="flex items-start gap-2.5">
            <span className="rounded-lg bg-violet-500/15 p-1.5 shrink-0">
              <Cookie className="h-4 w-4 text-violet-400" />
            </span>
            <p className="text-xs text-muted-foreground leading-relaxed">
              A gente usa cookies e armazenamento local pra <strong className="text-foreground">manter seu login</strong> e
              lembrar suas preferências (tipo o tema). Nada de rastrear você por aí nem vender dado.
              Detalhes na <Link to="/privacidade" className="text-violet-400 hover:text-violet-300 underline underline-offset-2">Política de Privacidade</Link>.
            </p>
          </div>
          <button
            data-testid="cookie-accept"
            onClick={accept}
            className="w-full rounded-full bg-violet-600 hover:bg-violet-500 text-white py-2 text-sm font-medium transition"
          >
            Entendi
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
